import React from "react"
import Images from "../../../components/Images/Images"

export const ShopOnlineBanner = ({ _query }) => {
  let banner
  _query.data.body.map(element => {
    if (element.__typename === "PrismicShopOnlinePageBodyBanner") {
      return banner = element.primary
    }else return null
  })

  return (
    <div className="so-banner">
      <div className="so-banner__bg">
        <Images
          sources={{
            mb: { url: banner.banner__image.xs.url },
            sm: { url: banner.banner__image.sm.url },
            md: { url: banner.banner__image.lg.url },
            lg: { url:  banner.banner__image.url},
            url:  banner.banner__image.url
          }}
          alt="Calorex shop online banner"
          loading="eager"
          className="so-banner__img"
        />
      </div>
      <div className="so-banner__header">
        <h1 className="so-banner__pagename">{_query.data.title.text}</h1>
        <h2 className="so-banner__title">{banner.banner_title.text}</h2>
        <p className="so-banner__description">
          {banner.banner_description.text}
        </p>
      </div>
    </div>
  )
}
